
import { authHeader } from '../_helpers';
import { CONST } from '../_config';
import CryptoJS from 'crypto-js';

export const userService = {
    userlogin,
    userAssessmentLogin,
    logout,
    validateOtp,
    validateAssessmentOtp,
    darwinboxVerify,

    userAssessmentRegistration,
    userAssessmentEmailVerify,
    userAssessmentSignIn,
    userAssessmentValidateOtp,

    contactUs,

    userResponselogin,
    validateResponseOtp,
    logoutSession,


    userEmployeeLogin,
    userEmployeeValidateOtp,
    userInsightCodeLogin


};

function logout() {
    localStorage.removeItem('adminuser');
    // window.location.href = "#/login";
}
function userlogin(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/userSurveyLogin`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                userinfoToken: user.data,
                is360: user && user.data && user.data.is360 ? true : false
            }

            return userObj;
        });
}



function logoutSession(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/logoutSession`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                userLogout: user
            }
            localStorage.removeItem('adminuser');
            // window.location.href = "#/response/signin/"+data;

            return userObj;
        });
}




function userEmployeeLogin(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userEmployeeLogin`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                userAssessmentinfoToken: user.data
            }

            return userObj;
        });
}


function userEmployeeValidateOtp(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userEmployeeValidateOtp`, requestOptions)
        .then(handleResponse)
        .then(user => {

            if (user.data) {
                localStorage.setItem('adminuser', JSON.stringify(user.data));
            }

            let userObj = {
                userAssessmentinfoToken: user.data
            }
            return userObj;
        });
}


function userInsightCodeLogin(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userInsightCodeLogin`, requestOptions)
        .then(handleResponse)
        .then(user => {

            if (user.data) {
                localStorage.setItem('adminuser', JSON.stringify(user.data));
            }

            let userObj = {
                userAssessmentinfoToken: user.data
            }
            return userObj;
        });
}



function userAssessmentLogin(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userAssessmentLogin`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                userinfoToken: user.data
            }

            return userObj;
        });
}

function validateOtp(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/validateSurveyOtp`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                userinfo: user.data
            }
            // if (user.data) {
            //     localStorage.setItem('adminuser', JSON.stringify(user.data));
            // }

            return userObj;
        });
}

function validateAssessmentOtp(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });

    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/validateAssessmentOtp`, requestOptions)
        .then(handleResponse)
        .then(user => {

            let userObj = {
                userinfo: user.data
            }

            if (user.data) {

                localStorage.setItem('adminuser', JSON.stringify(user.data));
            }


            return userObj;
        });
}


function contactUs(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/contactUs`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                contactUsData: data.data
            }
            return userObj;
        });
}


function darwinboxVerify(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/darwinboxVerify`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                darwinboxVerify: user.data
            }

            return userObj;
        });
}




function userAssessmentRegistration(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userAssessmentRegistration`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                userAssessmentRegistrationData: user.data
            }

            return userObj;
        });
}





function userAssessmentEmailVerify(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userAssessmentEmailVerify`, requestOptions)
        .then(handleResponse)
        .then(user => {
            if (user.data) {
                localStorage.setItem('adminuser', JSON.stringify(user.data));
            }

            let userObj = {
                userAssessmentEmailVerifyData: user.data
            }
            return userObj;
        });
}


function userAssessmentSignIn(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userAssessmentSignIn`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                userAssessmentinfoToken: user.data
            }

            return userObj;
        });
}


function userAssessmentValidateOtp(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userAssessmentValidateOtp`, requestOptions)
        .then(handleResponse)
        .then(user => {

            if (user.data) {
                localStorage.setItem('adminuser', JSON.stringify(user.data));
            }



            let userObj = {
                userAssessmentinfoToken: user.data
            }
            return userObj;
        });
}



function userResponselogin(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/userResponselogin`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                userinfoToken: user.data
            }

            return userObj;
        });
}

function validateResponseOtp(data) {

    let header = new Headers({
        'Content-Type': 'application/json'
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/validateResponseOtp`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                userinfo: user.data
            }
            if (user.data) {
                localStorage.setItem('adminuser', JSON.stringify(user.data));
            }
            return userObj;
        });
}





function handleResponse(response) {
    // console.log("response22222   ", response);

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                //location.reload(true);
            }
            // console.log("datadatadata ", response);

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        //console.log("datadatadatadatadata   ", data.error);
        if (data.error) {
            // console.log("datadatadatadatadata   ", data);
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}